export class NotificationChannelSettingRequestModel {
  notificationType: string;
  inAppEnabled: boolean;
  emailEnabled: boolean;
}
